(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/dialog/assets/javascripts/.trinidad/constants/type.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/dialog/assets/javascripts/.trinidad/constants/type.trinidad.js'); "use strict";

(() => {

  "use strict";


  var __webpack_require__ = {};





  (() => {

    __webpack_require__.d = (exports, definition) => {
      for (var key in definition) {
        if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }

      }

    };

  })();





  (() => {
    __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

  })();



  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => __WEBPACK_DEFAULT_EXPORT__

  });



  const CONFIRM = 'confirm';
  const ERROR = 'error';
  const DEFAULT = CONFIRM;

  const __WEBPACK_DEFAULT_EXPORT__ = {
    CONFIRM,
    DEFAULT,
    ERROR
  };
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).dialog = window.svs.ui.dialog || {}).type = __webpack_exports__.default;
})();
 })(window);